<template>
    <div>
        <div class="mb-6">
            <OrganizationRegistrationSelectInput
                v-if="allowCrossAttendance"
                v-model="registrationUuid"
                name="registration_id"
                label="Enfant"
                placeholder="Sélectionner un enfant (optionnel)"
                @select-registration="onSelectRegistration"
            />
            <RegistrationSelectInput
                v-else
                v-model="registrationUuid"
                name="registration_id"
                label="Enfant"
                @select-registration="onSelectRegistration"
            />
        </div>
        <AttendanceCreateForm
            v-if="registration"
            :baby="registration.baby"
            :registration="registration"
            :creche="creche"
            @created="$emit('created')"
        />
    </div>
</template>

<script>
export default {

    props: {
        creche: {
            type: Object,
            default: null
        },
        allowCrossAttendance: {
            type: Boolean,
            default: false
        }
    },

    emits: ['created'],

    data () {
        return {
            registrationUuid: undefined,
            registration: undefined,
            babies: []
        }
    },

    methods: {
        onSelectRegistration (registration) {
            console.log(registration)
            this.registration = registration
        }
    }
}
</script>
